import { useMutation } from '@tanstack/react-query';

import client from './client';
import SignInResp, { BaseResp } from './response';

export type Account = {
  account: string;
  passwd: string;
};

const signIn = (account: Account): Promise<SignInResp> => client.post('/v1/account/login', { ...account });
export const useSignInMutation = () => useMutation(signIn);

export const signOut = () => client.delete('/v1/account/logout');

const checkPassword = (passwd: string): Promise<BaseResp> => client.post('/v1/account/passCheck', { passwd });
export const useCheckPasswordMutation = () => useMutation(checkPassword);


export const signInSSo = (): Promise<SignInResp> => client.get('/v1/account/sso');

// const ping = (): Promise<BaseResp> => client.post('/v1/ping');
export const getPing = () => client.get('/v1/ping');
export const getSSOInfo = (): Promise<SignInResp> => client.get('/v2/account/info/sso');